// SPDX-License-Identifier: AGPL-3.0-or-later

export const KONVO_SEARCH_SOURCES = [
	'messages',
	'whatsapp',
	'teams',
	'mail',
	'tasks',
	'calendar',
	'files',
	'related',
] as const;
export type KonvoSearchSource = (typeof KONVO_SEARCH_SOURCES)[number];
export type KonvoSearchFilter = 'all' | 'people' | KonvoSearchSource;
export type KonvoSearchSourceState = 'ready' | 'disconnected' | 'indexing' | 'timeout' | 'error';
export type KonvoSearchSourceStates = Partial<Record<KonvoSearchSource, KonvoSearchSourceState>>;

const SOURCE_ALIASES: Record<string, KonvoSearchFilter> = {
	all: 'all',
	people: 'people',
	person: 'people',
	users: 'people',
	konvo: 'messages',
	convo: 'messages',
	messages: 'messages',
	chats: 'messages',
	whatsapp: 'whatsapp',
	wa: 'whatsapp',
	teams: 'teams',
	mail: 'mail',
	email: 'mail',
	emails: 'mail',
	tasks: 'tasks',
	calendar: 'calendar',
	events: 'calendar',
	files: 'files',
	file: 'files',
	docs: 'files',
	documents: 'files',
	attachments: 'files',
	related: 'related',
};

/** Source shortcuts also work without selecting a chip. Ordinary queries search every connector. */
export function parseKonvoSearchQuery(raw: string): {query: string; source: KonvoSearchFilter | null} {
	const query = raw.trim().slice(0, 200);
	const match = /^(?:in|source):([a-z]+)\b\s*(.*)$/i.exec(query) ?? /^([a-z]+):\s*(.*)$/i.exec(query);
	const source = match ? SOURCE_ALIASES[match[1].toLowerCase()] : undefined;
	return source ? {query: match![2].trim(), source} : {query, source: null};
}

export function konvoSearchSources(filter: KonvoSearchFilter): Array<KonvoSearchSource> {
	return filter === 'all' ? [...KONVO_SEARCH_SOURCES] : filter === 'people' ? [] : [filter];
}
